import React, { FC } from 'react';
import { LawFirmActionSlider } from './LawFirmActionSlider';
import { MobileBar } from '../../../components/mobile-bar/MobileBar';
import { SubHeaderContent } from '../../../components/sub-header/SubHeaderContent';

type Props = {
  isVisible: boolean;
};

export const LawFirmMobileBar: FC<Props> = ({ isVisible }) => (
  <MobileBar>
    <SubHeaderContent>
      <LawFirmActionSlider isVisible={isVisible} />
    </SubHeaderContent>
  </MobileBar>
);
